import { ofType } from "redux-observable";
import { merge } from "rxjs";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { invert } from "../../guards/invert";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionShowMe } from "../actionShowMe";
import { pathOpenMarketMenu } from "../path/pathOpenMarketMenu";
import { pathOpenQuestMenu } from "../path/pathOpenQuestMenu";
import { checkIfAnyQuestsExists } from "./checkIfAnyQuestsExists";
export var epicInsufficientLevel = function (action$, state$, deps) {
    var action1 = action$.pipe(ofType(TypeActionShowMe.InsufficientLevel), guard(state$, deps, pathEmpty)([
        combineChecks([checkIfAnyQuestsExists])(pathOpenQuestMenu),
    ]));
    var action2 = action$.pipe(ofType(TypeActionShowMe.InsufficientLevel), guard(state$, deps, pathEmpty)([
        combineChecks([invert(checkIfAnyQuestsExists)])(pathOpenMarketMenu),
    ]));
    return merge(action1, action2);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/insufficient-level/epicInsufficientLevel.ts
// module id = 2346
// module chunks = 3